// Centralised brand assets
export const brand = {
  logoUrl:
    "https://customer-assets.emergentagent.com/job_build-fleet-3/artifacts/m4coy9ra_image0%20%281%29.jpeg",
};
